<template>
  <el-dialog
    id="popup_dialog"
    :title="titlu"
    :visible.sync="showPopup"
    class="my-dialog-class custom-width"

  >
    <div class="container">
      <el-form
        label-position="top"
        :inline="false"
        :rules="rules"
        label-width="100%"
        :model="selectedObject"
        ref="my-form"
        @submit.prevent="save"
        v-loading="loadingVisible"
      >
        <el-row :gutter="15">
          <el-col :md="8">
            <el-form-item label="Nume" prop="Nume">
              <el-input class="full-width" v-model="selectedObject.Nume" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
          <el-form-item label="Centru productie" prop="IdCentruProductie">
            <el-select v-model="selectedObject.IdCentruProductie" class="full-width">
              <el-option
                v-for="item in Info.centre_productie"
                :key="'centre_productie' + item.Id"
                :label="item.Nume"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Categorii_produse_dialog",
  extends: BasePage,
  data() {
    return {
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        Nume: "",
        IdCentruProductie: "",
      },
      Info: {
        centre_productie: [],
      },
      rules: {
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga o categorie de produs";
        this.selectedObject= {};
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza o categorie de produs";
        var result = await this.post("categorii_produse/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },
    async get_info() {
      var response = await this.post("categorii_produse/get_info_for_dialog");
      this.Info.centre_productie = response.centre_productie;
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("categorii_produse/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject= {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog{
      min-width: 90vw !important;
    }
  }
}
</style>